// extracted by mini-css-extract-plugin
export var card = "card-module--card--dCwUR";
export var title = "card-module--title--y0cTN";
export var infos = "card-module--infos--GVz7U";
export var sections = "card-module--sections--tW0vd";
export var section = "card-module--section--Ilnkv";
export var headline = "card-module--headline--X0z4Q";
export var ingredients = "card-module--ingredients--QK-on";
export var instructions = "card-module--instructions--eTJjd";
export var fadein = "card-module--fadein--fyzQi";